<template>
    <div>
        <router-link :target="blank?'_blank':''" :to="{name: 'Catalog', query:{category: cat}}" class="badge bg-primary mr-2 text-capitalize" v-for="(cat, index) of categories" :key="index">
            {{cat}}
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'Categories',
    props: ['categories', 'blank'],
}
</script>

<style lang="scss" scoped>
.badge{
    text-decoration: none;
    opacity: 0.75;
    transition: all 0.5s;
    &:hover{
        opacity: 1;
        transform: translateY(-2px);
        filter: drop-shadow(0 2px 2px rgba(0,0,0,0.25));
        color: white;
    }
}
</style>